/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cdo_Status_ConfirmedInputs */

const vi_cdo_status_confirmed = /** @type {(inputs: Cdo_Status_ConfirmedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã xác nhận`)
};

/**

* @param {Cdo_Status_ConfirmedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const cdo_status_confirmed = /** @type {((inputs?: Cdo_Status_ConfirmedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cdo_Status_ConfirmedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cdo_status_confirmed(inputs)
});